import { FaCode, FaDatabase, FaNodeJs, FaPhp } from "react-icons/fa"; // Import icons
import { RxLinkBreak2 } from "react-icons/rx";
import { TiHomeOutline } from "react-icons/ti";
import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../contexts/UserContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import InfoBasic from "../modules/employees/InfoBasic";
import styled from "styled-components";
import CompetencyChart from "../modules/employees/CompetencyChart";
import CompetencyList from "../modules/employees/CompetencyList";
import InfoExtended from "../modules/employees/InfoExtended";
import useMenuTitle from "../hooks/useMenuTitle";
import useMenuSecondary from "../hooks/useMenuSecondary";

const EmployeeGridContainer = styled.div`
  display: grid;
  /* grid-template-columns: repeat(
    auto-fit,
    minmax(50rem, 1fr)
  );  */
  grid-template-columns: repeat(
    auto-fill,
    50rem
  ); // Flexible number of 50rem columns
  justify-content: start; // Aligns items to the start of the grid
  gap: 2rem; // Equivalent to 20px if 1rem = 16px.
  padding: 1rem; // Adds some spacing inside the container, adjust as necessary.
  box-sizing: border-box; // Ensures padding and border are included in the width calculation.

  @media (max-width: 768px) {
    grid-template-columns: repeat(
      auto-fit,
      minmax(15rem, 1fr)
    ); /* Smaller min width for smaller screens */
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(
      auto-fit,
      minmax(10rem, 1fr)
    ); /* Even smaller for very small screens */
  }
`;

const InfoBasicContainer = styled.div`
  display: flex;
  width: 50rem;
  align-content: flex-start;
  min-height: 50rem;
  height: auto;
  background-color: var(--backdrop-color);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-div-md);
  border-radius: 1rem;
`;

const InfoExtendedContainer = styled.div`
  display: flex;
  width: 50rem;
  align-content: flex-start;
  min-height: 50rem;
  height: auto;
  margin-top: 2rem;
  background-color: var(--backdrop-color);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-div-md);
  border-radius: 1rem;
`;

const CompetencyContainer = styled.div`
  display: flex;
  width: 50rem;
  align-content: flex-start;
  min-height: 50rem;
  height: auto;
  max-height: 50rem;
  background-color: var(--backdrop-color);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-div-md);
  border-radius: 1rem;
`;

function Employees() {
  useMenuTitle("Employees");

  const { userDetails } = useContext(UserContext);
  const witronUser = userDetails?.userCompany === "Witron";
  const token = userDetails.userWiMuleToken; // Extract the token

  // useMenu(menuItemsData);

  return (
    <>
      {witronUser ? (
        <EmployeeGridContainer>
          <div>
            <InfoBasicContainer>
              <InfoBasic token={token} />
            </InfoBasicContainer>
            <InfoExtendedContainer>
              <InfoExtended token={token} />
            </InfoExtendedContainer>
          </div>
          <CompetencyContainer>
            <CompetencyChart token={token} />
          </CompetencyContainer>
          <InfoBasicContainer>
            <CompetencyList token={token} />
          </InfoBasicContainer>
        </EmployeeGridContainer>
      ) : null}
    </>
  );
}

export default Employees;
